import { render, staticRenderFns } from "./ButtonElement.vue?vue&type=template&id=d163c8ec&scoped=true"
import script from "./ButtonElement.vue?vue&type=script&lang=js"
export * from "./ButtonElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d163c8ec",
  null
  
)

export default component.exports